module.exports=function(e,n){return{"value":n,"done":!!e}};